function pickRandomDateBetween(start, end) {
  return new Date(
    start.getTime() + Math.random() * (end.getTime() - start.getTime())
  )
}

function randomDigit() {
  return `${Math.trunc(Math.random() * 10)}`
}

function randomDigitString(length) {
  const digits = new Array(length)
  for (let i = 0; i < length; i++) {
    digits[i] = randomDigit()
  }

  return digits.join('')
}

function randomPhoneNumber() {
  const r = (n) => randomDigitString(n)

  return `${r(3)}-${r(3)}-${r(4)}`
}

function pickRandomArrayItem(array) {
  const numItems = array.length
  const index = Math.floor(Math.random() * numItems)

  return array[index]
}

function randomPASCODE() {
  const c = () => pickRandomArrayItem("0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ")
  const passcode = new Array(7)
  for (let i = 0; i< 7; i++) {
    passcode.push(c())
  }
  return passcode.join('')
}

/**
 * Create a random date between:
 *   [now - minusDays, now + plusDays]
 * @param minusDays 
 * @param plusDays 
 * @returns 
 */
function randomDateFromNow(minusDays: number, plusDays: number) {
  const now = new Date()
  const startDate = new Date(now)
  const endDate = new Date(now)
  startDate.setDate(startDate.getDate() - minusDays)
  endDate.setDate(endDate.getDate() + plusDays)

  const convertedStartDate = new Date(startDate)
  const convertedEndDate = new Date(endDate) 
  const startTimestamp = convertedStartDate.getTime()
  const endTimestamp = convertedEndDate.getTime()
  const randomTimestamp =
    startTimestamp + Math.random() * (endTimestamp - startTimestamp)
  const randomDate = new Date(randomTimestamp)
  return randomDate
}
function getRandomNumberBetween(min,max) {
  return Math.floor(Math.random() * (max - min + 1)) + min
}
function generateRandomTrueOrFalse() {
  return Math.random() < 0.5
}
export {
  generateRandomTrueOrFalse,
  getRandomNumberBetween,
  pickRandomArrayItem,
  pickRandomDateBetween,
  randomDateFromNow,
  randomDigit,
  randomDigitString,
  randomPASCODE,
  randomPhoneNumber,
}
